import { AppBar, Slide, styled, Toolbar, useScrollTrigger } from '@mui/material';
import { FC } from 'react';

interface Props {
	/**
	 * Injected by the documentation to work in an iframe.
	 * You won't need it on your project.
	 */

	window?: () => Window;
	children: React.ReactElement;
}

const HideOnScroll = (props: Props) => {
	const { children, window } = props;

	const trigger = useScrollTrigger({
		target: window ? window() : undefined,
		disableHysteresis: true,
		threshold: 50,
	});

	return (
		<Slide appear={false} direction='down' in={!trigger}>
			{children}
		</Slide>
	);
};

const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);

const ImageContainer = styled('div')({
	margin: '0 auto',
	display: 'flex',
	alignItems: 'center',
});

interface INavBarProps {
	Logo: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const UnauthorisedNavBar: FC<INavBarProps> = ({ Logo }) => (
	<>
		<HideOnScroll>
			<AppBar>
				<Toolbar>
					<ImageContainer>
						<Logo />
					</ImageContainer>
				</Toolbar>
			</AppBar>
		</HideOnScroll>
		<Offset />
	</>
);
export default UnauthorisedNavBar;
